import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import Notify from '@/components/Notification';
import { getMessage } from '@/helpers/utils';
import { userService } from '../../services/userService';

export const useValidatePhoneNumber = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: payload =>
      userService.validatePhoneNumber(payload).then(response => {
        const { status, data } = response;
        const message = getMessage(data);

        if (status === 200) {
          Notify.success({ text: message });
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.user.profile] });
          return { data, success: true };
        }

        if (status === 422) {
          return { data, success: false };
        }

        return null;
      }),
  });
};
